module.exports = __webpack_public_path__ + "static/media/help-center.2432ebb9.svg";